import { ArrowDown } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "./ui-bits";

const STAGES = [
  {
    n: "01",
    t: "Tell us what you need",
    c: "Requirement, location, size, budget and business objectives.",
  },
  {
    n: "02",
    t: "We find the opportunity",
    c: "Our network and market intelligence identify relevant spaces.",
  },
  {
    n: "03",
    t: "We evaluate & negotiate",
    c: "Site visits, commercial evaluation, due diligence and negotiation.",
  },
  {
    n: "04",
    t: "You close with confidence",
    c: "Documentation, coordination and handover.",
  },
];

const Process = () => (
  <section
    id="process"
    className="border-t border-obsidian/10 bg-ivory text-obsidian"
    data-testid="process-section"
  >
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <Eyebrow tone="dark">04 / The Process</Eyebrow>
      <h2 className="mt-6 font-serif text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
        <MaskLines lines={["FROM REQUIREMENT", "TO REALITY."]} />
      </h2>

      <div className="mt-16 grid gap-10 md:grid-cols-4 md:gap-8">
        {STAGES.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div className="relative border-t border-obsidian/20 pt-6" data-testid={`process-stage-${s.n}`}>
              <div className="flex items-center justify-between">
                <span className="font-serif text-4xl italic text-obsidian/25">{s.n}</span>
                {i < STAGES.length - 1 && (
                  <ArrowDown size={14} className="text-champagne md:hidden" />
                )}
              </div>
              <h3 className="mt-5 text-sm font-medium uppercase tracking-[0.18em]">
                {s.t}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-obsidian/65">{s.c}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
